import http from '../../services/http';


export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('getFullPriceAndFiling', (formGroup) => ({
        formGroup,
        inputs: {
          entity_type: '',
          entity_state: '',
        },
        errors: {},
        content: '',
        async getFullPriceAndFiling() {
          if (!this.inputs.entity_type || !this.inputs.entity_state) {
            return;
          }

          const apiUrl = 'https://api.incfile.com/api/v1/getFullPriceAndFiling/';
          const response = await http.get(
            `${apiUrl}?state=${this.inputs.entity_state}&entityType=${this.inputs.entity_type}`,
            {
              headers: null,
            },
          );
          if (response.status !== 200) {
            return;
          }

          const { data } = response;
          this.content = this.processHtmlContent(data?.filings?.requirement);
        },
        processHtmlContent(rawHtml){
          const wrapper = document.createElement('div');
          wrapper.innerHTML = rawHtml;

          const innerContainer = wrapper.firstElementChild;
          if (!innerContainer) return rawHtml;

          const originalChildren = Array.from(innerContainer.children);
          const newChildren = [];

          let buffer = [];

          const flushBuffer = () => {
            if (buffer.length === 0) return;

            // Add <hr> between each <p> if more than one
            const groupedItems = [];
            buffer.forEach((el, idx) => {
              groupedItems.push(el);
              if (idx < buffer.length - 1) {
                groupedItems.push(document.createElement('hr'));
              }
            });

            const container = document.createElement('div');
            container.className = 'content-container';
            groupedItems.forEach(item => container.appendChild(item));
            newChildren.push(container);

            buffer = [];
          };

          originalChildren.forEach((el) => {
            if (el.tagName === 'P') {
              // Clone to avoid touching live DOM
              const clone = el.cloneNode(true);

              // Wrap costs in span to add specific styles
              const newNodes = [];
              clone.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('$')) {
                  const replaced = node.textContent.replace(
                    /(\$\d+(?:\.\d{2})?|\$[^\s]+)/g,
                    '<span class="cost">$1</span>',
                  );
                  const span = document.createElement('span');
                  span.innerHTML = replaced;
                  newNodes.push(...span.childNodes);
                } else {
                  newNodes.push(node);
                }
              });
              clone.replaceChildren(...newNodes);

              buffer.push(clone);
            } else {
              flushBuffer();
              newChildren.push(el.cloneNode(true));
            }
          });

          flushBuffer();

          // Replace everything at once
          innerContainer.replaceChildren(...newChildren);

          return wrapper.innerHTML;
        },
        validateField(fieldName) {
          delete this.errors[fieldName];
          if (!this.inputs[fieldName]?.trim() && fieldName) {
            this.errors[fieldName] = 'Please complete this required field.';
          }
          this.getFullPriceAndFiling();
        },
        validateAll() {
          this.validateField('entity_type');
          this.validateField('entity_state');
        },
        submit(baseURL) {
          this.validateAll();
          if (this.errors.entity_type || this.errors.entity_state) {
            return;
          }
          const url = `${baseURL}?entity_type=${this.inputs.entity_type}&entity_state=${this.inputs.entity_state}`;
          window.location.href = url;
        },
      }));
    });
  },
};
